<script>
  import { personnelProps, initValue } from './index.js'
  import i18n from './i18n'
  import Api from './api.js'
  import response from '../../../../../../utils/response'
  const pageText = window.fe.getPageText(i18n)

  export default {
    props: {
      ...personnelProps,
      personList: Array
    },
    data () {
      return {
        pageText,
        info: ''
      }
    },
    computed: {
      selectValue () {
        return this.personList.find(v => v.id === this.select?.id) || this.select || {}
      },
      dataSource () {
        return this.disabledPopover
      }
    },
    methods: {
      async getDetailById () {
        const {type, url} = Api.getInfoByIds
        const params = [this.selectValue.id]
        const {isOk, content} = await response(this.$http(type, url, params))

        if (isOk) {
          const item = content[0]

          if (item) {
            this.info = item
            this.info.rm = this.organizationModel(item)
          }
        }
      },
      organizationModel ({organizationModel} = {}) {
        let department = ''
        const iteration = ({name, organizationModel: rm}) => {
          if (name) {
            department += `${department ? ' > ' : ''}${name}`
          }

          if (rm) {
            iteration(rm)
          }
        }

        organizationModel && iteration(organizationModel)
        return department
      },
      hover () {
        if (!this.info) {
          this.getDetailById()
        }
      }
    },
    render () {
      const value = initValue(this.selectValue)
      return (
        this.selectValue.name
          ? <el-popover
            placement="top-start"
            popper-class='popper-color'
            trigger="hover"
            on-show={this.hover}
            disabled={this.dataSource}
          >
            <span slot="reference">
              <read-text class="personnel-pure-text" {...this.$props} value={value}></read-text>
            </span>
            <div class="popover-content">
              <p><span>{pageText.name}: </span><span>{this.info.name}</span></p>
              <p><span>{pageText.organizationDepartment}: </span><span>{this.info.rm}</span></p>
              <p><span>{pageText.jobNumber}: </span><span>{this.info.workNumber}</span></p>
            </div>
          </el-popover>
          : <span>-</span>
      )    
    }
  }
</script>
<style scoped lang="scss">
  .popover-content {
    font-size: 12px;

    & > p {
      margin-bottom: 8px;
    }
  }
</style>
<style lang='scss'>
   .popper-color.el-popover{
    background: #303133 !important;
    color: #fff;
  }

  .popper-color[x-placement^=left] .popper__arrow::after{
    border-left-color: #303133;
  }
  .popper-color[x-placement^=right] .popper__arrow::after{
    border-right-color: #303133;
  }
  .popper-color[x-placement^=bottom] .popper__arrow::after{
    border-bottom-color: #303133;
  }
  .popper-color[x-placement^=top] .popper__arrow::after{
    border-top-color: #303133;
  }
  .personnel-pure-text{
    width: auto !important;
  }
</style>